<template>
	<div class="full zhe">
		
		<div class="game_alert_light"><img src="../img/game_alert_light.png" /></div>
		<div class="game_alert">
			<img :src="require('../img/game_alert_'+level+'_'+type+'.png')" />
		</div>
		<div class="game_alert_back" v-hammer:tap="back"><img src="../img/game_alert_back.png" /></div>
	</div>
</template>

<style scoped>
	.game_alert_back {
		position: absolute;
		width: 7.2%;
		left: 74.9%;
		top: 30.9%;
	}

	.game_alert_light {
		position: absolute;
		width: 98%;
		left: 1.1%;
		top: 26.4%;

	}

	.game_alert {
		position: absolute;
		width: 60.8%;
		left: 20.8%;
		top: 33.3%;
	}

	.game_alert_light {
		-webkit-animation: game_alert_light 6s linear infinite;
	}

	@-webkit-keyframes game_alert_light {
		0% {
			-webkit-transform: rotate(0deg);
		}

		100% {
			-webkit-transform: rotate(360deg);
		}
	}
</style>
<script>
	export default {
		props: {
			type: {
				type: Number,
				default: function() {
					return 0
				}
			},
			level: {
				type: Number,
				default: function() {
					return 0
				}
			}
		},
		data() {
			return {

			};
		},
		computed: {

		},
		mounted() {

		},
		watch: {

		},
		methods: {
			back() {
				this.$emit('back', {
					type: this.type
				})
			}
		},
		components: {

		}
	}
</script>
